import EmployeeContext from '../../components/context-menu/EmployeeContext';
import TableContext from '../../components/context-menu/TableContext';
import store from '../../store/store.js';

export default class CreateAllocationsColumns {
  returnValueOrCallbackValue(valueOrFunction, params) {
    return typeof valueOrFunction === 'function' ? valueOrFunction(params) : valueOrFunction;
  }
  execute(data, fromInternalProjects = false, projectId) {
    const source = fromInternalProjects ? data.internalProjectAllocations : data.projectAllocations;
    const columns = source.columns.filter((columnData) =>
      ['PLAN', 'FACT'].includes(columnData.name),
    );
    const deletedEmployeeColumns = data.capacity.columns
      .filter((col) => col.isDeleted)
      .map((col) => col.columnId);
    const categoryId = data.capacity.columnsCategoryId;

    const columnDefs = [
      {
        rowDrag: true,
        editable: false,
        pinned: 'right',
        width: 70,
        rowDragText: this.renderRowDragText,
      },
      {
        field: 'name',
        headerName: '',
        pinned: 'left',
        editable: (params) => {
          if (!store.getters.hasPermission(projectId, 'capacities_edit')) return false;

          if (params.data.editable) {
            return params.data.editable(params);
          }
          return true;
        },
        cellRenderer: 'collapseCellRenderer',
        cellRendererParams: {
          defaultCollapsed: (params) => {
            if (params.data.hasSubitems) {
              return this.collapsedParentItems.has(params.data.itemId);
            }
            return true;
          },
          isVisible: (params) => {
            return params.data.hasSubitems;
          },
          iconSide: () => 'left',
          openIcon: () => 'ChevronRightIcon',
          closeIcon: () => 'ChevronUpIcon',
          onOpen: (params) => {
            this.collapsedParentItems.delete(params.data.itemId);
            params.api.gridCore.gridApi.onFilterChanged();
          },
          onCollapse: (params) => {
            this.collapsedParentItems.add(params.data.itemId);
            params.api.gridCore.gridApi.onFilterChanged();
          },
        },
        cellStyle: (params) => {
          return {
            ...(params.data.parent && {
              'padding-left': '25%',
            }),
          };
        },
        cellClass: (params) => {
          if (params.data.nameCellClass) {
            return params.data.nameCellClass;
          }
        },
        onCellValueChanged: (event) => {
          if (event.data.onCellValueChanged) {
            event.data.onCellValueChanged(event);
          }
        },
        onCellContextMenu: (cellContextMenuEvent) => {
          if (!cellContextMenuEvent.data.editable(cellContextMenuEvent)) {
            return;
          }

          this.$root.$emit('contextmenu', {
            event: cellContextMenuEvent.event,
            ctxMenuWidget: {
              component: TableContext,
              props: {
                isHidden: cellContextMenuEvent.data.isHidden,
                isTopLevel: cellContextMenuEvent.data.parentItemId === null,
                onAddSubitemsClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.addRow(source.itemsCategoryId, cellContextMenuEvent.data.itemId);
                },
                onHideClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.toggleProjectVisibility(cellContextMenuEvent);
                },
                onShowClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.toggleProjectVisibility(cellContextMenuEvent);
                },
              },
            },
          });
        },
      },
      ...columns.map((columnData) => ({
        field: columnData.columnId,
        itemId: columnData.itemId,
        isDeleted: deletedEmployeeColumns.includes(columnData.parentColumnId),
        headerName: '',
        width: 120,
        editable: (params) => {
          if (!store.getters.hasPermission(projectId, 'capacities_edit')) return false;

          if (params.data.editable) {
            return params.data.editable(params);
          }
          return true;
        },
        onCellValueChanged: (event) => {
          if (event.data.onCellValueChanged) {
            event.data.onCellValueChanged(event);
          }
        },
        cellStyle: (params) => {
          const nonnullSubitem = (params.data.subitems || []).some((item) => {
            return !item.isDeleted && item[params.column.colId] !== 0;
          });

          return nonnullSubitem ? { 'background-color': '#f2f2f2' } : {};
        },
        cellClass: (params) => {
          if (params.data.cellClass) {
            // Check if data.format is a function or value
            return typeof params.data.cellClass === 'function'
              ? params.data.cellClass(params)
              : params.data.cellClass;
          }
        },
        colSpan: (params) => {
          if (params.data.colSpan) {
            return params.data.colSpan;
          }

          return 1;
        },
        valueFormatter: (params) => {
          if (!params.data.format) {
            return params.value;
          }

          const format =
            typeof params.data.format === 'function'
              ? params.data.format(params)
              : params.data.format;

          return `${params.value || 0} ${format}`;
        },
        onCellContextMenu: (cellContextMenuEvent) => {
          if (cellContextMenuEvent.node.rowIndex !== 0) {
            return;
          }

          this.$root.$emit('contextmenu', {
            event: cellContextMenuEvent.event,
            ctxMenuWidget: {
              component: EmployeeContext,
              props: {
                isDeleted: cellContextMenuEvent.colDef.isDeleted,
                onDeleteClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.deleteEmployee(categoryId, cellContextMenuEvent.colDef.itemId);
                },
                onRestoreClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.restoreEmployee(categoryId, cellContextMenuEvent.colDef.itemId);
                },
                onCapacityClicked: () => {
                  this.$root.$emit('closeContextmenu');
                  this.defaultCapacityEmployeeId = cellContextMenuEvent.colDef.itemId;
                  this.$refs.defaultCapacityDialog.openDialog({
                    id: cellContextMenuEvent.colDef.itemId,
                    name: cellContextMenuEvent.value,
                  });
                },
              },
            },
          });
        },
      })),
    ];
    return columnDefs;
  }
}
